/** Cores padrão ABNT para fibras ópticas (sequência oficial brasileira, repete a cada 12) */
export const CORES_ABNT_FIBRA = [
  { cor: '#4CAF50', nome: 'Verde' },
  { cor: '#FFEB3B', nome: 'Amarelo' },
  { cor: '#FFFFFF', nome: 'Branco' },
  { cor: '#2196F3', nome: 'Azul' },
  { cor: '#F44336', nome: 'Vermelho' },
  { cor: '#9C27B0', nome: 'Roxo' },
  { cor: '#795548', nome: 'Marrom' },
  { cor: '#E91E63', nome: 'Rosa' },
  { cor: '#212121', nome: 'Preto' },
  { cor: '#9E9E9E', nome: 'Cinza' },
  { cor: '#FF9800', nome: 'Laranja' },
  { cor: '#00BCD4', nome: 'Aqua' },
] as const;

/** Cores EIA/TIA-598-A (repete a cada 12 portas no DIO) */
export const CORES_EIA598_FIBRA = [
  { cor: '#1565C0', nome: 'Azul' },
  { cor: '#FF8F00', nome: 'Laranja' },
  { cor: '#2E7D32', nome: 'Verde' },
  { cor: '#795548', nome: 'Marrom' },
  { cor: '#78909C', nome: 'Ardósia' },
  { cor: '#FFFFFF', nome: 'Branco' },
  { cor: '#D32F2F', nome: 'Vermelho' },
  { cor: '#212121', nome: 'Preto' },
  { cor: '#FDD835', nome: 'Amarelo' },
  { cor: '#7B1FA2', nome: 'Violeta' },
  { cor: '#EC407A', nome: 'Rosa' },
  { cor: '#00ACC1', nome: 'Aqua' },
] as const;

export type PadraoCoresFibra = 'abnt' | 'eia598a';

export const SPLITTER_PADROES_CORES = [
  { value: 'sem_padrao', label: 'Sem Padrão' },
  { value: 'abnt', label: 'ABNT' },
  { value: 'eia598a', label: 'EIA-598-A' },
] as const;

export type PadraoCoresSplitter = typeof SPLITTER_PADROES_CORES[number]['value'];

export const getPadraoCoresSplitterLabel = (padrao?: PadraoCoresSplitter | null): string =>
  SPLITTER_PADROES_CORES.find((item) => item.value === padrao)?.label ?? 'Sem Padrão';

export const getCorFibra = (numeroFibra: number, padrao: PadraoCoresFibra = 'abnt') => {
  const cores = padrao === 'eia598a' ? CORES_EIA598_FIBRA : CORES_ABNT_FIBRA;
  const indice = (numeroFibra - 1) % 12;
  return cores[indice];
};

/** Índice da cor ABNT/EIA para saída de splitter (1x16/1x32 reinicia na 9ª saída). */
export const getIndiceCorSplitterSaida = (portaNum: number, totalOutputs: number): number => {
  if (totalOutputs === 16 || totalOutputs === 32) {
    return (portaNum - 1) % 8;
  }
  return (portaNum - 1) % 12;
};

export const getCorFibraSplitter = (
  portaNum: number,
  totalOutputs: number,
  padrao: PadraoCoresFibra,
) => {
  const cores = padrao === 'eia598a' ? CORES_EIA598_FIBRA : CORES_ABNT_FIBRA;
  return cores[getIndiceCorSplitterSaida(portaNum, totalOutputs)];
};
